<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'PFormationMatching'
});
</script>
<template>
  <ka-container
    code="p-formation-matching"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <ka-text code="matching-matchers">
      <span v-html="t('pFormationMatching.matchingMatchers.value', `<strong>Matching Matchers </strong>`)" />
    </ka-text>
    <!-- Container gauche -->
    <ka-container code="container-gauche">
      <ka-image
        code="image"
        :options="{
          animationIn: `fadeIn`,
          lazyOptions: {
            throttle: 200,
            once: true,
            intersection: { threshold: 0.1 }
          },
          imgFit: `cover`,
          alt: componentInstance.$descriptionImageAlt.value
        }"
        :value="componentInstance.$image.value" />
      <!-- Container -->
      <ka-container code="container">
        <ka-text
          code="text"
          :value="componentInstance.$descriptionCompany.value" />
      </ka-container>
    </ka-container>
    <!-- Container droite -->
    <ka-container code="container-droite">
      <ka-image
        code="image-1"
        :options="{
          animationIn: `fadeIn`,
          lazyOptions: {
            throttle: 200,
            once: true,
            intersection: { threshold: 0.1 }
          },
          imgFit: `cover`,
          alt: componentInstance.$descriptionImageAlt.value
        }"
        :value="componentInstance.$photoExpert.value" />
      <!-- Container -->
      <ka-container code="container-1">
        <ka-text
          code="text-1"
          :value="componentInstance.$expertText.value" />
      </ka-container>
    </ka-container>
    <!-- Container bas -->
    <ka-container code="container-bas">
      <!-- Chiffre 1 -->
      <ka-container code="chiffre-1">
        <ka-text
          code="chiffre"
          :value="componentInstance.$trainingHours.value" />
        <ka-text
          code="texte"
          :value="componentInstance.$supportDuration.value" />
      </ka-container>
      <!-- Chiffre 2 -->
      <ka-container code="chiffre-2">
        <ka-text
          code="text-2"
          :value="componentInstance.$budgetAvailable.value" />
        <ka-text code="text-3">
          <span v-html="t('pFormationMatching.containerBas.chiffre2.text3.value', `De financement obtenu.`)" />
        </ka-text>
      </ka-container>
      <!-- Chiffre 2 -->
      <ka-container code="container-2">
        <ka-text
          code="text-4"
          :value="componentInstance.$remainsDependent.value" />
        <ka-text code="text-5">
          <span v-html="t('pFormationMatching.containerBas.container2.text5.value', `Reste à charge pour l'entreprise.`)" />
        </ka-text>
      </ka-container>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { pFormationMatchingComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c31')
const component = pFormationMatchingComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  descriptionCompany?: Nullable<string>
  expertText?: Nullable<string>
  remainsDependent?: Nullable<string>
  budgetAvailable?: Nullable<string>
  trainingHours?: Nullable<string>
  supportDuration?: Nullable<string>
  photoExpert?: Nullable<string | File>
  descriptionImageAlt?: Nullable<string>
  image?: Nullable<string | File>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  descriptionCompany: '<strong>Digifield</strong> | Salariée chargée de la relation client chez BlaBlaCar.<br> <br> <br><strong>Problématique : </strong><br><br>Développement d’un nouvel outil par deux développeurs en alternance qui manquaient de sensibilité et de formation en UI/UX design.<br> ',
  expertText: '<strong>Loris </strong>| CMO chez MonChasseurImmo.<br> <br> <br><strong>Expertise : </strong><br><br>Plus de 9 ans d\'expérience dans le transport (bus) au service des clients. Management d’une équipe de 15 personnes.<br> ',
  remainsDependent: '0€',
  budgetAvailable: '2800€',
  trainingHours: '2h',
  supportDuration: 'd\'accompagnement à raison de 2h de formation par semaine.',
  photoExpert: 'https://ucarecdn.com/9e9646a1-16d8-45f6-b6a4-51c6cfe028b7/',
  descriptionImageAlt: 'description image',
  image: 'https://ucarecdn.com/58d4b84b-2664-4969-917c-b5fd83b863cf/',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:descriptionCompany',
  'update:expertText',
  'update:remainsDependent',
  'update:budgetAvailable',
  'update:trainingHours',
  'update:supportDuration',
  'update:photoExpert',
  'update:descriptionImageAlt',
  'update:image'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    descriptionCompany: true,
    expertText: true,
    remainsDependent: true,
    budgetAvailable: true,
    trainingHours: true,
    supportDuration: true,
    photoExpert: true,
    descriptionImageAlt: true,
    image: true
  }
})
</script>
